import { Injectable } from '@angular/core';
import { COMMON_WORDS } from '../../constants/constants';

@Injectable({
  providedIn: 'root',
})
export class BankMatcherService {
  normalizeText(text: string): string {
    return text
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9\s]/g, '')
      .trim();
  }

  findBestMatch(
    ocrName: string,
    options: { label: string; value: any }[],
  ): { label: string; value: any } | undefined {
    const normalizedOcr = this.normalizeText(ocrName);

    const ocrKeywords = normalizedOcr
      .split(/\s+/)
      .filter((word) => word.length > 2 && !COMMON_WORDS.includes(word));

    let bestMatch: { label: string; value: any } | undefined;
    let bestScore = 0;

    for (const option of options) {
      const normalizedOption = this.normalizeText(option.label);

      if (normalizedOcr === normalizedOption) {
        return option;
      }

      if (
        normalizedOcr.includes(normalizedOption) ||
        normalizedOption.includes(normalizedOcr)
      ) {
        return option;
      }

      const optionKeywords = normalizedOption
        .split(/\s+/)
        .filter((word) => word.length > 2 && !COMMON_WORDS.includes(word));

      let score = 0;
      for (const ocrWord of ocrKeywords) {
        for (const optWord of optionKeywords) {
          if (ocrWord.includes(optWord) || optWord.includes(ocrWord)) {
            score++;
          }
        }
      }

      if (score > bestScore) {
        bestScore = score;
        bestMatch = option;
      }
    }

    return bestScore > 0 ? bestMatch : undefined;
  }
}
